export const attachingMode = {
  NEW_FILES: 'NEW_FILES',
  EXISTING_FILES: 'EXISTING_FILES',
  EXISTING_EXPORTS: 'EXISTING_EXPORTS',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
} as const

export type AttachingMode = typeof attachingMode[keyof typeof attachingMode]
